// extracted by mini-css-extract-plugin
export default {"cookieModalContainer":"CookieModal_cookieModalContainer__lmbuS","cookieModal":"CookieModal_cookieModal__h0LGa","action":"CookieModal_action__SdRiL"};